"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateWorkflowRequest_CREATIVE_WORK_TAGGING_Dec = exports.CreateWorkflowRequest_CREATIVE_WORK_TAGGING = exports.BaseCreateWorkflowRequest = void 0;
const D = __importStar(require("io-ts/lib/Decoder"));
const client_1 = require("@prisma/client");
const codecs_1 = require("../../codecs");
const function_1 = require("fp-ts/lib/function");
const Workflow_CreativeWorkConfig_1 = require("./Workflow_CreativeWorkConfig");
class BaseCreateWorkflowRequest {
}
exports.BaseCreateWorkflowRequest = BaseCreateWorkflowRequest;
class CreateWorkflowRequest_CREATIVE_WORK_TAGGING extends BaseCreateWorkflowRequest {
}
exports.CreateWorkflowRequest_CREATIVE_WORK_TAGGING = CreateWorkflowRequest_CREATIVE_WORK_TAGGING;
exports.CreateWorkflowRequest_CREATIVE_WORK_TAGGING_Dec = (0, function_1.pipe)(D.struct({
    priority: D.nullable(codecs_1.PriorityDec),
    workflowType: D.literal(client_1.WorkflowType.CREATIVE_WORK_TAGGING),
    resourceId: D.string,
    resourceTitle: D.string,
    cwmClassType: D.string,
    cwmClassTypeLabel: D.string,
    assignee: D.nullable(D.string),
    workflowConfig: Workflow_CreativeWorkConfig_1.Workflow_CreativeWorkConfigInputDec,
    deadlineAt: D.nullable(codecs_1.DateFromISOString),
    source: D.nullable(D.string),
    radarId: D.number,
}), D.withMessage(() => 'CreateWorkflowRequest'));
//# sourceMappingURL=CreateWorkflowRequest.dto.js.map